import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { cellGrow } from "constants/styles";
import { UI_THEME } from "utils/constants/ui";
import Pill from "components/Pill";
import startCase from "lodash/startCase";
import { MANIFEST_STATUS } from "utils/constants/manifest";
import { ManifestOptionPropTypes } from "utils/propTypes";

const ManifestOption = ({ model, isFirst, isLast, isActive, onClick }) => {
  const { id, title, status, previewUrl } = model;

  const callout =
    status === MANIFEST_STATUS.LIVE ? startCase(MANIFEST_STATUS.LIVE) : null;

  return (
    <div
      className={classnames(
        "ba br2 bg-white w-100 relative cell-grow bg-white--hover pointer",
        {
          "ba--primary": isActive,
          "hairline-1": !isActive
        }
      )}
      onClick={() => onClick(id)}
    >
      <div className="flex flex-column bb hairline-1 justify-between pa3">
        <div className="flex flex-row justify-between items-start">
          <div className="flex flex-row items-center w-100">
            <div
              className={"f4 fw6 color-primary lh-title"}
              style={{ marginTop: 2 }}
            >
              {title}
            </div>
          </div>
          {callout && (
            <div className="dib">
              <Pill copy={callout} theme={UI_THEME.SLIM} />
            </div>
          )}
        </div>
        {previewUrl && (
          <div className="f6 lh-copy pt2 mt1 color-text--primary">
            {previewUrl}
          </div>
        )}
      </div>
      <style jsx>{cellGrow}</style>
    </div>
  );
};

ManifestOption.propTypes = {
  model: PropTypes.shape(ManifestOptionPropTypes),
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool,
  isActive: PropTypes.bool,
  onClick: PropTypes.func
};

export default ManifestOption;
